class Recaptcha {
    #siteKey = "";
    #loaded = false;

    constructor() {
        this.init();
        this.bindEvents();
    }

    init() {
        const widget = document.querySelector('[data-id="widget-recaptcha"]');
        if (!widget) return;

        this.siteKey = widget.dataset.key || '';
        widget.removeAttribute('data-key');
    }

    bindEvents() {
        document.addEventListener('reCaptcha_domInjection', (e) => {
            if (e.cancelable) e.preventDefault();
            this.domInjection();
        });

        document.addEventListener('recaptcha3_generate_token', (e) => {
            if (e.cancelable) e.preventDefault();
            this.generateToken(e);
        });

        document.addEventListener('recaptcha_reset', (e) => {
            if (e.cancelable) e.preventDefault();
            this.resetRecaptcha();
        });
    }

    domInjection() {
        if (!this.loaded) {
            this.loaded = true;
            this.loadRecaptcha();
            return;
        }

        this.resetRecaptcha();
    }

    loadRecaptcha() {
        if (!this.siteKey) {
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?render=' + this.siteKey
        script.defer = true;

        document.body.appendChild(script);
    }

    generateToken(event) {
        const { origin: target = '', action = 'undefined' } = event.detail || {};

        if (!this.isReady()) {
            this.dispatchTokenEvent(target, '');
            return;
        }

        grecaptcha.ready(() => {
            grecaptcha.execute(this.siteKey, { action }).then((token) => {
                this.dispatchTokenEvent(target, token);
            });
        });
    }

    isReady() {
        return (
            this.siteKey &&
            typeof grecaptcha !== 'undefined' &&
            typeof grecaptcha.ready === 'function'
        );
    }

    dispatchTokenEvent(target, token) {
        document.dispatchEvent(new CustomEvent('recaptcha3_token_generated', {
            detail: { target, token },
            cancelable: true
        }));
    }

    resetRecaptcha() {
        const el = document.querySelector('.g-recaptcha');
        if (typeof grecaptcha === 'undefined' || !el) return;

        const sitekey = el.getAttribute('data-sitekey') || '';
        if (el.innerHTML.trim() === '' && sitekey) {
            grecaptcha.render(el, { sitekey });
        } else {
            grecaptcha.reset();
        }
    }
}

export default Recaptcha;
